import React from "react";
import ReusableUserHead from "../ui/ReusableUserHead";

export default function UserHeader({ open }) {
  return <ReusableUserHead open={open} />;
}
